/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
/* */
// 'use strict'

expocadfx.Drawing3d = function() {
    var config = expocadfx.config;
    var data = expocadfx.fxData;
    var elemById = expocadfx.element.elementById;
    var BoothText = expocadfx.BoothText;
    var FxEvent = expocadfx.fxevent;
	var util = expocadfx.util;
    
    var doc = document;
    
    var CENTER_X = config.DRAWING_WIDTH / 2;
    var CENTER_Y = config.DRAWING_HEIGHT / 2;
    
    var arSelected = [];
    var arHighlight = [];
    var arFavorites = [];
    var arOutline = [];
    var arOutlineParams = [];
	var overlaysAdded = false;
    
    var fitScale = 0;
    var targetX = 0;            // floor plan point that is at the center of the window
    var targetY = 0;
    var initialOffsetX = 0;
    var initialOffsetY = 0;
    
        // keep track of array lengths outside of loop
    var numPavilions = 0;
    
    var updateNeeded = true;
    var loopStarted = false;
    
    var effectInProgress = false;
    
    var zoomingOut = false;
    var zoomingIn = false;
    
    var panning = false;
    var panFinalX = 0;
    var panFinalY = 0;
    var panDirectionX = 1;
    var panDirectionY = 1;
    var zoomFinalDist = 0;
    var effectTime = 0;
    
	var loopSize = 50;
	var boothsDone = 0;
	
    var scene = null;
    var group = null;
    var camera = null;
    var renderer = null;
    
    var active = true;
    var updateTimer = null;
	var isReady = false;
	
	var rotating = false;
	var pendingInitialZoom = null;
    
        //  amount needs to be based on drawing scale, somehow
    var extrudeHeight = config.scaleFactor;
    
    if( config.oldVersion) {
        extrudeHeight = config.scaleFactor < 0.2 ? 160 :
                            config.scaleFactor < 0.3 ? 84 :
                            config.scaleFactor < 0.4 ? 60 :
                            config.scaleFactor < 1 ? 36 :
                            config.scaleFactor < 1.6 ? 16 :
                            config.scaleFactor < 2 ? 14 : 8;
    }
    
    var extrudeSettings = { amount: extrudeHeight,
                           bevelEnabled: false
                          };
    
    var idleCount = 0;
    
    var mouse = new THREE.Vector2();
    var raycaster;
    
    var rFOV = 50 * Math.PI / 180;      //  camera verticle Field Of View in radians
    var initialCameraDistance = 0;
    var currentCameraDistance = 0;
    
    var drawingRotation = -0.25 * Math.PI;   // 45 degrees in radions
    var sin45 = Math.sin( -drawingRotation);
    
    var floorMesh;
    var boothMeshes = [];
    var overlayMeshes = [];
    
    var pointerAt = { x:0, y:0};
    
    var containerWidth = elemById( "floorplan").clientWidth;
    var containerHeight = elemById( "floorplan").clientHeight;
	var container = elemById( "fpContainer");
	
	var light = null;
	var mesh = null;

	container.style.backgroundColor = config.clrBackground;       // move to page setup

	targetX = CENTER_X;
	targetY = CENTER_Y;

	fitScale = calculateScale();
	calculateInitialOffset();
//	console.log( "3d fit scale: " + fitScale);
	initialCameraDistance = Math.floor( ( containerHeight /2) / Math.tan( rFOV / 2) +
		Math.sin( Math.PI/4) * (config.DRAWING_HEIGHT/2) * fitScale);

	currentCameraDistance = initialCameraDistance;

	camera = new THREE.PerspectiveCamera( 50, containerWidth / containerHeight, 1, 2200);

	renderer = new THREE.WebGLRenderer( { antialias: true,
										alpha: true,
										preserveDrawingBuffer: true,
										logarithmicDepthBuffer: true});

	renderer.setClearColor(  0xf0f0f0, 0 );
	renderer.setPixelRatio( window.devicePixelRatio );
	renderer.setSize( containerWidth, containerHeight);

	scene = new THREE.Scene();

	camera.position.z = initialCameraDistance;
	camera.lookAt(new THREE.Vector3(0, 0, 0));

	container.appendChild( renderer.domElement);

	light = new THREE.AmbientLight( 0xffffff, 0.4);
	scene.add( light);

	light = new THREE.SpotLight( 0xffffff, 0.8 );
	light.position.set( 0, 100, 800);
	light.castShadow = true;
	scene.add( light );

	group = new THREE.Group();
	group.scale.set( fitScale, fitScale, fitScale);

	scene.add( group );

	if( data.debug) {
		mesh = new THREE.Mesh( new THREE.BoxGeometry( 50, 50, 50, 1, 1, 1 ),
								new THREE.MeshBasicMaterial( {color: 0x0000ff} ) );
		mesh.position.set( 0, 0, 0);
		group.add( mesh);
	}

	raycaster = new THREE.Raycaster();
        
	window.onbeforeunload = function() {
		//  appears to fix IE11 extreme slow load on reload/refresh 
		renderer.clear();
	};
	
	
    function addBuilding( buildingImage) {
        var floorMaterial = new THREE.MeshBasicMaterial();
        var texture = new THREE.Texture();

        texture.format = THREE.RGBFormat;
        texture.generateMipmaps = false;
        texture.magFilter = THREE.LinearFilter;
        
        texture.image = buildingImage;
        texture.needsUpdate = true;

        floorMaterial.map = texture;
        floorMaterial.map.minFilter = THREE.LinearFilter;
                                                        
        floorMesh = new THREE.Mesh( new THREE.PlaneGeometry(
            config.DRAWING_WIDTH, config.DRAWING_HEIGHT, 96, 96), floorMaterial);
        floorMesh.receiveShadow = true;

		
        checkBuildingText();
        
        group.add(floorMesh);
        
        updateNeeded = true;
    }
    
    function calculateScale() {
        var effHeight = config.DRAWING_HEIGHT * Math.sin( -drawingRotation);
        return Math.min( containerWidth / config.DRAWING_WIDTH,
                        effHeight / config.DRAWING_HEIGHT);
    }
    
    function calculateInitialOffset() {
            initialOffsetX = Math.round(( containerWidth / fitScale - config.DRAWING_WIDTH) / 2);
            initialOffsetY = Math.max( Math.round(( containerHeight /fitScale - config.DRAWING_HEIGHT)/2), 0);
    }
    
    function enableEvents() {
        doc.addEventListener( "Mini_Map_Change", miniMapResponse);
       if( doc.hidden === "undefined") {
            console.log( "NO document hidden object");
        }
        else {
            doc.addEventListener( "visibilitychange", pageVisible);
        }
    }
    
    function disableEvents() {
        doc.removeEventListener( "Mini_Map_Change", miniMapResponse);
		doc.removeEventListener( "visibilitychange", pageVisible);
    }
    
    function miniMapResponse( evt) {
        moveCamera( evt.data.x * fitScale, evt.data.y * fitScale);
    }
	
	function pageVisible() {
		if( !doc.hidden) {
			renderScene();
			console.log( "Render on Visible");
		}
	}
    
    function renderScene() {
        
        renderer.render( scene, camera);
    }
    
	function checkBuildingText() {
		if( data.status.buildingTextReady) {
			addBuildingText();
		}
		else {
			setTimeout( checkBuildingText, 10);
		}
	}
	
    function addBuildingText() {
        var canvas;
        var ctx;
        var mesh = null;
        var textWidth = 0;
		
        
		data.buildingText.forEach( function( txt) {
            canvas = doc.createElement( "canvas");
            ctx = canvas.getContext( "2d");
			
            ctx.font = txt.fontSize + "px " + config.FLOOR_PLAN_FONT;
			
                // measureText can return 0 for single characters!
            textWidth = Math.max( ctx.measureText( txt.text).width, 2);
            
            canvas.width = textWidth;
            canvas.height = txt.fontSize;
			
			ctx.fillStyle = config.clrBuildingText;		// changing canvas size resets fillStyle to #000000
			
            drawTextToCanvas( ctx, 
                             txt.text,
                             txt.fontSize,
                             textWidth / 2,
                             0.33 * txt.fontSize,
                             0);
			
            mesh = meshFromCanvas( canvas, true, txt.fontSize);

            mesh.rotation.z = -txt.rotation;
            mesh.position.set( txt.x - targetX,
                              -(txt.y - targetY + 8),
                              1);
			
            floorMesh.add( mesh);
        });
		
		if( data.addedGraphics) {
			data.addedGraphics.graphics.forEach( function( graphic) {
				if( graphic.type === "F") {
					graphic.center = { x: 0.5 * ( graphic.maxX + graphic.minX),
									y: 0.5 * ( graphic.maxY + graphic.minY)};
					floorMesh.add( drawLine( graphic));
				}
				else {
					floorMesh.add( drawArcs( graphic));
				}
			});

			data.addedGraphics.txt.forEach( function( txt) {
				addText( txt, false);
			});
		}
		

		data.arArcs.forEach( function( arc) {
			floorMesh.add( drawArcs( arc));
		});
		
		data.arCircles.forEach( function( circle) {
			floorMesh.add( drawArcs( circle));
		});
	}
	
	function drawArcs( obj) {
		var cx = obj.x - CENTER_X;
		var cy = -(obj.y - CENTER_Y);
		
		var curve = new THREE.EllipseCurve( cx, cy, 
											obj.radius, obj.radius, 
											obj.startAngle, -obj.endAngle, 
											true, 0);
		
		var path = new THREE.Path( curve.getPoints( 50) );
		
//  Not in THREE version 86		
//		var geometry = new THREE.BufferGeometry()
//		geometry.setFromPoints( curve.getPoints( 50) );
		
		var geometry = path.createPointsGeometry( 50);
		
		var material = new THREE.LineBasicMaterial( { color : obj.strokeColor, linewidth: obj.lineWidth } );
		var arc = new THREE.Line( geometry, material );
		arc.position.z = 1;
		return arc;
	}
	
//	function addSquare( x, y, z, color) {
//		mesh = new THREE.Mesh( new THREE.BoxGeometry( 50, 50, 50, 1, 1, 1 ),
//								new THREE.MeshBasicMaterial( {color: color} ) );
//		mesh.position.set( x, y, z);
//		group.add( mesh);
//	}
    
    function addPavilionsToFloor() {
        var i = 0;
        var j = 0;
        var graphic = null;
        var shape = null;
        var material = null;
        var geometry = null;
//        var line = null;
//        var lineMaterial = null;  // = new THREE.LineBasicMaterial( {color: 0xff0000});
        
        ///////////   Pavilions and Graphics    ////////////////////
        for( i = 0; i < numPavilions; i++) {
            graphic = data.pavilions[i];
            graphic.center = { x: 0.5 * ( graphic.maxX + graphic.minX),
                            y: 0.5 * ( graphic.maxY + graphic.minY)};

            graphic.vertices = [];
			
            if( graphic.type === "P") {
				for (j = 0; j < graphic.numPoints; j++) {

					graphic.vertices.push( new THREE.Vector2 (graphic.path[j].x - graphic.center.x,
															-( graphic.path[j].y - graphic.center.y)));
				}
                shape = new THREE.Shape( graphic.vertices);
                geometry = new THREE.ShapeBufferGeometry( shape);
                material = new THREE.MeshLambertMaterial( {color: graphic.fillColor,
                                                    transparent: true,
                                                    opacity: graphic.alpha});

                graphic.mesh = new THREE.Mesh( geometry, material);
                graphic.mesh.position.set( graphic.center.x - targetX, targetY - graphic.center.y, 1 );
                group.add( graphic.mesh );
            }
            else {
                group.add( drawLine( graphic));
            }
        }
    }
	
	function drawLine( graphic) {
		var j = 0;
		var line = null;
		var lineMaterial = null;
		var geometry = new THREE.Geometry();
		
		for (j = 0; j < graphic.numPoints; j++) {
			geometry.vertices.push( new THREE.Vector3 (graphic.path[j].x - graphic.center.x,
														-( graphic.path[j].y - graphic.center.y),
														0.5));
		}
		lineMaterial = new THREE.LineBasicMaterial( { color: graphic.expColor, 
														linewidth: config.additionalGraphicsLineWidth });
		line = new THREE.Line( geometry, lineMaterial);
		line.position.set( graphic.center.x - targetX, targetY - graphic.center.y, 2);

		return line;
	}
    
    function setIAmHere( symbol, label, x, y, color) {
        var canvas = doc.createElement( "canvas");
        var ctx = canvas.getContext( "2d");
        var mesh = null;
        var textWidth = 0;
        
        ctx.font = "bold 116px 'Font Awesome 5 Free'";
        textWidth = ctx.measureText( label).width;
        
        canvas.width = textWidth;
        canvas.height = 300;
        
        ctx.fillStyle = color;
        ctx.font = "bold 116px 'Font Awesome 5 Free'";
        ctx.fillText( label, 0, 96);
        
        ctx.font = "bold 160px 'Font Awesome 5 Free'";
        ctx.fillText( symbol, 0.5 * canvas.width - 68, 272);
        
        mesh = meshFromCanvas( canvas, true);
        mesh.position.set( x - CENTER_X, CENTER_Y - y, 96);
        mesh.rotation.x = 0.25 * Math.PI;
        group.add( mesh);
        updateNeeded = true;
    }
    
    function addFloorPlanText() {
//        var i;
//        var canvas = null;
//        var ctx = null;
//        var mesh;
//        var numText = data.floorPlanText.length;
//        var textWidth = 0;
//		var top = false;
		
		data.pavilionLabels.forEach( function( txt) {
			addText( txt, true);
		});
		
		data.floorPlanText.forEach( function( txt) {
			addText( txt, false);
		});
        
//        for( i = 0; i < numText; i++) {
//            canvas = doc.createElement( "canvas");
//            ctx = canvas.getContext( "2d");
//            ctx.font = "Bold " + data.floorPlanText[i].fontSize + "px " + config.FLOOR_PLAN_FONT;
//
//            renderer.domElement.appendChild( canvas);
//            textWidth = Math.max( ctx.measureText( data.floorPlanText[i].text).width, 2);
//            renderer.domElement.removeChild( canvas);
//
//            canvas.width = textWidth;
//            canvas.height = data.floorPlanText[i].fontSize;
//            
//            ctx.fillStyle = config.clrBoothText;
//          
//            drawTextToCanvas( ctx,
//                             data.floorPlanText[i].text,
//                             data.floorPlanText[i].fontSize,
//                             textWidth / 2,
//                             0.33 * data.floorPlanText[i].fontSize,
//                             0
//                             );
//
//            mesh = meshFromCanvas( canvas, true, data.floorPlanText[i].fontSize);
//
//            mesh.rotation.z = -data.floorPlanText[i].rotation;
//            //  need to make z variable, this puts text above booths !!
//            mesh.position.set( data.floorPlanText[i].x - targetX,
//                              -(data.floorPlanText[i].y - targetY),
//                              extrudeHeight + 16);
//            
//            group.add( mesh);
//        }
    }
	
	function addText( txt, isTop) {
		var textWidth = 0;
		var ht = isTop? extrudeHeight + 16 : 1;
		var canvas = doc.createElement( "canvas");
		var ctx = canvas.getContext( "2d");
		ctx.font = "Bold " + txt.fontSize + "px " + config.FLOOR_PLAN_FONT;

		renderer.domElement.appendChild( canvas);
		textWidth = Math.max( ctx.measureText( txt.text).width, 2);
		renderer.domElement.removeChild( canvas);

		canvas.width = textWidth;
		canvas.height = txt.fontSize;

		ctx.fillStyle = config.clrBoothText;

		drawTextToCanvas( ctx,
						txt.text,
						txt.fontSize,
						textWidth / 2,
						0.33 * txt.fontSize,
						0
						);

		mesh = meshFromCanvas( canvas, true, txt.fontSize);

		mesh.rotation.z = -txt.rotation;
		//  need to make z variable, this puts text above booths !!
		mesh.position.set( txt.x - targetX, -(txt.y - targetY), ht);

		group.add( mesh);
	}
    
    function drawTextToCanvas( context, text, fontSize, locX, locY, rotation) {
        context.font = fontSize + "px " + config.FLOOR_PLAN_FONT;
        var textWidth = context.measureText( text).width;
        
        if( rotation !== 0) {
            context.save();
            
            context.translate( locX, locY);
            context.rotate( rotation);
            context.translate( -locX, -locY);
            
            context.fillText( text, locX - 0.5 * textWidth, locY + 0.5 * fontSize);
            context.restore();
        }
        else {
            context.fillText( text, locX - 0.5 * textWidth, locY + fontSize/2);
        }
    }
    
    function meshFromCanvas( canvas, ignoreDepth) {
        var material;
        var mesh;
        
        var texture = new THREE.Texture( canvas);
        texture.generateMipmaps = false;
        texture.magFilter = THREE.LinearFilter;
        texture.minFilter = THREE.LinearFilter;
        texture.needsUpdate = true;

        material = new THREE.MeshLambertMaterial( {map: texture});
        if( ignoreDepth) {
            material.depthWrite = false;
            material.depthTest = false;
        }
        
        material.map.minFilter = THREE.LinearFilter;
        material.transparent = true;
        
        mesh = new THREE.Mesh( new THREE.PlaneBufferGeometry( canvas.width, canvas.height),
                              material);
        return mesh;
    }
    
    function completeSetup() {
        var numBooths = data.boothGraphics.length;
        var i = 0;
        
        if( boothMeshes.length === 0) {
            for( i = 0; i < numBooths; i++) {
                addBoothGraphic( data.boothGraphics[i]);
            }
        }
		
		graphicTextLoop();
		
        updateNeeded = true;
		rotating = true;
        rotateToStart();
        
        numPavilions = data.pavilions.length;
        addPavilionsToFloor();
		if( data.status.overlaysReady && data.arOverlays.length > 0) {
			addOverlays();
		}
        addFloorPlanText();
		isReady = true;
    }
    
	//  breaks up loop because Chrome v69 kept loosing test on one booth
	function graphicTextLoop() {
		var i = 0;
		var end = Math.min( boothsDone + loopSize, data.boothGraphics.length);
		
		for( i = boothsDone; i < end; i++) {
			addBoothText( data.boothGraphics[i]);
		}
		
		if( end < data.boothGraphics.length) {
			boothsDone = end;
			setTimeout( graphicTextLoop, 0);
		}
		else {
			doc.dispatchEvent( new FxEvent( "Floor_Plan_Ready", null));
		}
	}
	
	
    function addBoothGraphic( graphic) {
        var shape = null;
        var geometry = null;
        var material = null;
        var edges = null;
        var j = 0;
		var edgeWidth = 0.0;
        
        graphic.center = { x: 0.5 * ( graphic.maxX + graphic.minX),
                            y: 0.5 * ( graphic.maxY + graphic.minY)};
        if( graphic.hasSize) {
                //  set center of booth and create vertices

            graphic.vertices = [];
            for (j = 0; j < graphic.numPoints; j++) {
                graphic.vertices.push( new THREE.Vector2 (graphic.path[j].x - graphic.center.x,
                                                          -( graphic.path[j].y - graphic.center.y)));
            }

            shape = new THREE.Shape( graphic.vertices );
            geometry = new THREE.ExtrudeBufferGeometry( shape, extrudeSettings);

            material = new THREE.MeshLambertMaterial( {color: graphic.fillColor,
                                                transparent: true,
                                                opacity: graphic.alpha});

            graphic.mesh = new THREE.Mesh( geometry, material);
            graphic.mesh.boothIndex = graphic.index;

            graphic.mesh.position.set( graphic.center.x - targetX, targetY - graphic.center.y, 0.5 );

            boothMeshes.push( graphic.mesh);

			
                // draw edges around booths - needed for border color from EXPOCAD ?
				//  linewidth parameter of THREE.LinesBasicMaterial has no effect on Windows platform
            geometry = new THREE.EdgesGeometry( graphic.mesh.geometry);
			
			edgeWidth = parseFloat( config.boothBorderLineWidth);
            var mat = new THREE.LineBasicMaterial( { color: graphic.strokeColor,
													linewidth: edgeWidth});
            edges = new THREE.LineSegments( geometry, mat);
            graphic.mesh.add( edges);

            group.add( graphic.mesh );
        }
        else {
            // create minimum size mesh for booth with 0 width or 0 length
            graphic.mesh = new THREE.Mesh(
                new THREE.BoxGeometry( 1, 1, 1),
                new THREE.MeshBasicMaterial( { color: graphic.fillColor, wireframe: false})
            );

            graphic.mesh.position.set( graphic.center.x - targetX, targetY - graphic.center.y, 0.5 );

            group.add( graphic.mesh);

            boothMeshes.push( graphic.mesh);
            
            data.floorPlanText = data.floorPlanText.concat( graphic.text);
        }
    }
    
	function addBoothText( graphic) {
		graphic.textMesh = new BoothText( graphic, targetX, targetY, extrudeHeight + 1); //12
//		console.log( "Add Text - booth  " + graphic.text[0].text + 
//					"  mesh: " + typeof(graphic.textMesh) + "   material: " + 
//				   graphic.textMesh.material + "   texture: " + graphic.textMesh.material.map);
		graphic.mesh.add( graphic.textMesh);
	}
	
    function addOverlays() {
        var material = null;
        var texture = null;
        var mesh = null;
        var img = null;
        var i = 0;
        var numOverlays = data.arOverlays.length;
        var posX = 0;
        var posY = 0;
		
		if( !data.status.overlaysReady) {
			return;
		}
		
        if( !overlaysAdded) {
			overlaysAdded = true;
			for( i = 0; i < numOverlays; i++) {
				if( data.arOverlays[i].ready) {		//  false if error loading overlay
					img = data.arOverlays[i].imgElement;

					material = new THREE.MeshBasicMaterial( {color:0xffffff, transparent:true});

					texture = new THREE.Texture();
					texture.image = img;
					texture.needsUpdate = true;

					material.map = texture;
					material.map.minFilter = THREE.LinearFilter;
					material.transparent = true;

					posX = data.arOverlays[i].x  - CENTER_X;
					posY = CENTER_Y - data.arOverlays[i].y;

					posX += data.arOverlays[i].w / 2;
					posY -= data.arOverlays[i].h / 2;

					mesh = new THREE.Mesh( new THREE.PlaneGeometry( 
						data.arOverlays[i].w, data.arOverlays[i].h, 96, 96), material);

					mesh.position.set( posX, posY, extrudeHeight + 1);
					mesh.rotation.z = data.arOverlays[i].rot;
					mesh.ovIndex = i;
					
					group.add( mesh);
					overlayMeshes.push( mesh);
				}
			}
		}
    }
    
    function cameraZoom( direction) {
        var zoomStep = 0;
        
        if( direction > 0) {
            zoomStep = 0.1 * currentCameraDistance;
            
            if( currentCameraDistance - zoomStep > 10) {
                camera.position.z -= zoomStep;
            }
        }
        else {
            zoomStep = ( currentCameraDistance / 0.9) - currentCameraDistance;
            
            if( currentCameraDistance + zoomStep < initialCameraDistance) {
                camera.position.z += zoomStep;
            }
        }
        
        currentCameraDistance = getCameraDistance();
                                       
        updateNeeded = true;
    }
    
    function getCameraDistance() {
        var intersects;
        var cX = camera.position.x / containerWidth;
        var cY = camera.position.y / containerHeight;
        
        mouse.set( cX, cY );
        raycaster.setFromCamera( mouse, camera);
        intersects = raycaster.intersectObjects( [floorMesh]);
        if ( intersects.length > 0 ) {
            return intersects[0].distance;
        }
        else {
            return currentCameraDistance;
        }
    }
    
    function moveCamera( dx, dy) {      // only used by I Am Here ?! --> dragTo()
        dy = sin45 * dy;
        camera.position.x -= dx;
        camera.position.z -= dy;
        camera.position.y += dy;
        
        updateNeeded = true;
    }
    
    function hitTest( x, y) {
        var intersects;
        var newX = ( x / containerWidth) * 2 - 1;       // normalize  -1 to +1
        var newY = - ( y / containerHeight) * 2 + 1;
        var i;
        var newIntersect = null;
        
        mouse.set( newX, newY);
        
        raycaster.setFromCamera( mouse, camera);
        
        intersects = raycaster.intersectObjects( boothMeshes, true);
//        intersects = raycaster.intersectObjects( group.children, true);
        if ( intersects.length > 0 ) {
            for( i = 0; i < intersects.length; i++) {
                if( intersects[i].object.hasOwnProperty( "boothIndex")) {
                    newIntersect = data.booths[ intersects[ i].object.boothIndex];
                    break;
                }
            }
        }
        if( newIntersect === null) {
            intersects = raycaster.intersectObjects( overlayMeshes, true);
            if( intersects.length > 0) {
                newIntersect = data.arOverlays[ intersects[0].object.ovIndex];
            }
        }
        return newIntersect;
    }
    
    function rotateToStart() {
        group.rotation.x = (group.rotation.x - 0.05 >= drawingRotation) ?
            group.rotation.x - 0.05 : drawingRotation;
        
        renderScene();
        
        if( group.rotation.x > drawingRotation) {
            setTimeout( rotateToStart, 60);
        }
        else {
            camera.updateProjectionMatrix();
			//  ready to zoomToBooth if needed
			rotating = false;
			if( pendingInitialZoom) {
				goToPoint( pendingInitialZoom.x, pendingInitialZoom.y, pendingInitialZoom.r);
				pendingInitialZoom = null;
			}
        }
    }
    
//    function logCameraPosition() {
//        console.log( "Cam pos  x: " + camera.position.x + ", y: " + camera.position.y +
//                        ", z: " + camera.position.z + "    Rot X: " + camera.rotation.x);
//    }
    
    function fitDrawing() {     // drawing size and offset have not changed
        //reset camera position, distance and target
        
        camera.position.x = 0;
        camera.position.y = 0;
        camera.position.z = initialCameraDistance;
        
        targetX = CENTER_X;
        targetY = CENTER_Y;
        currentCameraDistance = initialCameraDistance;
        updateNeeded = true;
    }
    
    function resizeHandler() {
        containerWidth = elemById( "floorplan").clientWidth;
        containerHeight = elemById( "floorplan").clientHeight;
        
        fitScale = calculateScale();
        calculateInitialOffset();
         
        initialCameraDistance = Math.floor( ( containerHeight /2) / Math.tan( rFOV / 2) +
            Math.sin( Math.PI/4) * (config.DRAWING_HEIGHT/2) * fitScale);
        
        camera.aspect = containerWidth / containerHeight;
        camera.updateProjectionMatrix();
        
        renderer.setSize( containerWidth, containerHeight);
        group.scale.set( fitScale, fitScale, fitScale);
        
        updateNeeded = true;
        
        return { x: initialOffsetX, y: initialOffsetY};
    }
    
    function globalToFloorPlan( gPt) {
        var lPt = null;
        var intersects;
        var newX = ( gPt.x / containerWidth) * 2 - 1;
        var newY = - ( gPt.y / containerHeight) * 2 + 1;
        
        mouse.set( newX, newY);
        raycaster.setFromCamera( mouse, camera);
        intersects = raycaster.intersectObjects( [floorMesh], true);
        
        if ( intersects.length > 0 ) {
            lPt = {};
            lPt.x = Math.round( intersects[0].point.x / fitScale + CENTER_X);
            lPt.y = Math.round( CENTER_Y - (intersects[0].point.y / fitScale / sin45));
        }
        return lPt;
    }
    
    function findPoint( pointerX, PointerY) {
        var intersects;
        var nX = ( pointerX / containerWidth) * 2 - 1;
        var nY = - ( PointerY / containerHeight) * 2 + 1;
        
        mouse.set( nX, nY);
        
        raycaster.setFromCamera( mouse, camera);
        
        intersects = raycaster.intersectObjects( [floorMesh]);
        if ( intersects.length > 0 ) {
            
            return { x:intersects[0].point.x, y:intersects[0].point.y};
        }
        return null;
    }
    
    function pointerDownAt( pointerX, PointerY) {
        var pt = findPoint( pointerX, PointerY);
        if( pt) {
            pointerAt = pt;
        }
    }
    
    function dragTo( pointerX, pointerY) {
        //  pointerAt set on mouse down, pointer down or touch start
        var dx;
        var dy;
        var pt = findPoint( pointerX, pointerY);
        if( pt) {
            dx = ( pt.x - pointerAt.x);
            dy = ( pt.y - pointerAt.y);
            
            camera.position.x -= dx;
            camera.position.y -= dy;
            camera.position.z += dy;
            
            //  force update
            updateNeeded = true;
            updateCheck();
            
            pointerAt = findPoint( pointerX, pointerY);
        }
    }
    
    function removeBoothText( bth) {
        var graphic = data.boothGraphics[ bth.index];
        
        if( graphic) {
            graphic.text = [];
            updateNeeded = true;
        }
    }
    
    function addGraphic( graphic) {
        data.pavilions.push( graphic);
        numPavilions += 1;
    }
    
    function highlightBooth( boothIndex) {
        var arTemp = boothIndex === -1 ? [] : String(boothIndex).split( ",");
        var bthMesh = null;
            //  remove existing highlights
		arHighlight.forEach( function( boothIndex) {
				//  three.js uses "0x" instead of "#", carry over from Flash Player!
			boothMeshes[ boothIndex].material.color.setHex(
				data.boothGraphics[ boothIndex].fillColor.replace( "#", "0x"));
		});
        
        if( boothIndex !== "-1") {
			arTemp.forEach( function( boothIndex) {
                bthMesh = boothMeshes[ boothIndex];
                if( bthMesh) {
                    bthMesh.material.color.setHex( config.clrHighlight.replace( "#", "0x"));
                }
			});
			
        }
        arHighlight = ( boothIndex !== "-1") ? arTemp : [];
        updateNeeded = true;
    }
    
    function addToOutline( obj, color, width) {
        var index = arOutline.indexOf( obj);
        if( index === -1) {
            arOutline.push( obj);           //  why 2 arrays ??
            arOutlineParams.push( {"color": color, "width": width});
        }
    }
    
    function removeFromOutline( obj) {
        if( obj === null) {
            arOutlineParams = [];
            arOutline = [];
        }
        else {
            var index = arOutline.indexOf( obj);
            if( index !== -1) {
                arOutlineParams.splice( index, 1);
                arOutline.splice( index, 1);
            }
        }
    }
    
    function markFavorite( boothIndex) {		// index or comma sepatated string of indexes
		var SIZE = config.scaleFactor / 0.7;
        var arTemp = String( boothIndex).split( ",");
        var len = arTemp.length;
        var i = 0;
		var text = String.fromCharCode(config.FAVORITE_CHARACTER_CODE);
        var canvas = null;
        var ctx = null;
        var mesh = null;
        var boothGraphic = null;
		
		//  check to see if there is already a mark for the booth
        for( i = 0; i < len; i++) {
            boothGraphic = data.boothGraphics[ arTemp[i]];
			
			if( !util.arrayFind( arFavorites, "index", boothGraphic.index)) {
				canvas = doc.createElement( "canvas");
				canvas.width = SIZE;
				canvas.height = SIZE;
				ctx = canvas.getContext( "2d");

				ctx.fillStyle = config.clrHighlight;
				ctx.globalAlpha = 0.7;

				ctx.font = "700 " + SIZE + "px 'Font Awesome 5 Free'";
				var textWidth = ctx.measureText( text).width;
				
				ctx.fillText( text, 0.5 * (SIZE - textWidth), 0.9 * SIZE);

				mesh = meshFromCanvas( canvas, true);
				mesh.index = boothGraphic.index;

				mesh.rotateZ( boothGraphic.text[0].rotation );

				mesh.position.z = extrudeHeight + 1;
				boothGraphic.mesh.add( mesh);

				arFavorites.push( mesh);
			}
        }
        updateNeeded = true;
    }
    
    function removeFavorite( boothIndex) {
        var len = arFavorites.length;
        var i = 0;
        
        for( i = 0; i < len; i++) {
            if( arFavorites[i].index === parseInt(boothIndex, 10)) {
                data.boothGraphics[boothIndex].mesh.remove( arFavorites[i]);
                arFavorites.splice( i, 1);
                updateNeeded = true;
                break;
            }
        }
    }
    
    function markSelected( boothGraphic) {
		var text = String.fromCharCode(config.SELECTED_CHARACTER_CODE);
        var canvas = null;
        var ctx = null;
        var mesh = null;
        var textX = 0;
        var textY = 0;
		
            //  is booth already marked
		if( util.arrayFind( arSelected, "index", boothGraphic.index)) {
			return;
		}
		
		canvas = doc.createElement( "canvas");
		canvas.width = 170 * config.MULTIPLIER;                         ///////////
		canvas.height = 170 * config.MULTIPLIER;
		ctx = canvas.getContext( "2d");

		textX = boothGraphic.minX + 0.5 * (boothGraphic.maxX - boothGraphic.minX);
		textY = boothGraphic.minY + 0.25 * (boothGraphic.maxY - boothGraphic.minY);
		
		ctx.fillStyle = config.clrSelected;
        ctx.globalAlpha = 0.8;

		//ctx.font = "bold " + canvas.height -12 + "px 'Font Awesome 5 Free'";           //////////
		ctx.font = "bold 116px 'Font Awesome 5 Free'";           //////////
		var textWidth = ctx.measureText( text).width;
        
		ctx.fillText( text, 0.5 * (canvas.width - textWidth), 0.88 * canvas.height);

		mesh = meshFromCanvas( canvas, false);
		mesh.index = boothGraphic.index;

		mesh.position.set( textX - targetX, -(textY - targetY), extrudeHeight + canvas.height/2);
		mesh.rotation.x = 0.25 * Math.PI;

		group.add( mesh);

		arSelected.push( mesh);
        
        updateNeeded = true;
    }
    
    function removeSelected( boothIndex) {
        var len = arSelected.length;
        var i = 0;
        
        for( i = 0; i < len; i++) {
            if( arSelected[i].index === boothIndex) {
                group.remove( arSelected[i]);
                arSelected.splice( i, 1);
                updateNeeded = true;
                break;
            }
        }
        updateNeeded = true;
    }
    
    function removeAllSelected() {
        var mesh = null;
        
        while( arSelected.length > 0) {
            mesh = arSelected.pop();
            group.remove( mesh);
        }
        updateNeeded = true;
    }
    
    function updateSelected( ar) {
        var len = ar.length;
        var i;
        
        for( i = 0; i < len; i++) {
            markSelected( data.boothGraphics[ ar[i].index] );
        }
        updateNeeded = true;
    }
    
    function goToPoint( newX, newY, ratio) {
		//  if rotating, WAIT
		if( rotating) {
			pendingInitialZoom = {
				x: newX,
				y: newY,
				r: ratio
			};
			return;
		}
		
        zoomFinalDist = initialCameraDistance  / ( 8 * ratio);
//        console.log( "final zoom distance: " + zoomFinalDist + "  initial: " + initialCameraDistance);
        panFinalX = Math.round( (newX - CENTER_X) * fitScale);     //  in drawing points
        panFinalY = -Math.round( sin45 * (newY - CENTER_Y) * fitScale);
        
        panDirectionX = ( camera.position.x - panFinalX < 0) ? 1 : -1;
        panDirectionY = panFinalY - camera.position.y;
        
        effectTime = Date.now();
        effectInProgress = true;
        
        if( panFinalX === camera.position.x && panFinalY === camera.position.y) {
            zoomingIn = true;
        }
        else {
            if( camera.position.z + camera.position.y < initialCameraDistance -1) {
                zoomingOut = true;
            }
            else {
                panning = true;
            }
        }
        updateNeeded = true;
    }
    
    function updateEffect() {
        var time = Date.now();
        var step = 0;
        
        if( zoomingOut) {
            step = 0.5 * (time - effectTime);
            if( camera.position.z + camera.position.y + step < initialCameraDistance) {
                camera.position.z += step;
            }
            else {
                camera.position.z = initialCameraDistance - camera.position.y;
                zoomingOut = false;
                panning = true;
            }
            currentCameraDistance = camera.position.z + camera.position.y;  
        }
        else if( zoomingIn) {
            step = 0.5 * (time - effectTime);
            if( camera.position.z - step > zoomFinalDist - camera.position.y) {
                camera.position.z -= step;
            }
            else {
                zoomingIn = false;
                effectInProgress = false;
            }
            currentCameraDistance = camera.position.z + camera.position.y;
        }
        else if( panning) {
            step = 0.75 * (time - effectTime);
            if( panDirectionX < 0) {
                if( camera.position.x - step <= panFinalX) {
                    camera.position.x = panFinalX;
                }
                else {
                    camera.position.x -= step;
                }
            }
            else {
                if( camera.position.x + step >= panFinalX) {
                    camera.position.x = panFinalX;
                }
                else {
                    camera.position.x += step;
                }
            }
            
            if( panDirectionY < 0) {
                if( camera.position.y - step <= panFinalY) {
                    camera.position.y = panFinalY;
                    camera.position.z = initialCameraDistance + panFinalY;
                }
                else {
                    camera.position.y -= step;
                    camera.position.z += step;
                }
            }
            else {
                if( camera.position.y + step >= panFinalY) {
                    camera.position.y = panFinalY;
                    camera.position.Z = initialCameraDistance - panFinalY;
                }
                else {
                    camera.position.y += step;
                    camera.position.z -= step;
                }
            }
            if( camera.position.x === panFinalX && camera.position.y === panFinalY) {     //  
                panning = false;
                zoomingIn = true;
            }
        }
        else {
            effectInProgress = false;
        }
        effectTime = time;
        updateNeeded = true;
    }
    
    function updateCheck() {
        if( !active) {
            return;
        }
        var ratio = currentCameraDistance/initialCameraDistance;
//        updateAnimation();
        if(effectInProgress ) {
            updateEffect();
        }
//        cameraControl();
        if( updateNeeded || idleCount > 40) {
            idleCount = 0;
          
            renderScene();
            if( updateNeeded) {
                doc.dispatchEvent( new FxEvent( "Floor_Plan_Change",
                                               { ratio: ratio,
                                                x:camera.position.x/fitScale + CENTER_X,
                                                y:(-(camera.position.y/sin45)/fitScale + CENTER_Y) } ));
                
            }
            updateNeeded = false;
        }
        else {
            idleCount += 1;
        }
        if( updateTimer !== null) {
            clearTimeout( updateTimer);
        }
        updateTimer = setTimeout( updateCheck, 100);
    }
    
    function printFloorPlan( full) {
        var currentLocation = camera.position.clone();
        var fpImg = null;
        
        if( full) {
            camera.position.set( 0, 0, initialCameraDistance);
            renderer.render( scene, camera);
        }
        fpImg = renderer.domElement.toDataURL( 'image/png');
        
        camera.position.copy( currentLocation);
        renderer.render( scene, camera);
        
        return fpImg;
    }
    
    function remove3dFloorPlan() {
        if( renderer) {
            container.removeChild( renderer.domElement);
        }
		clearTimeout( updateTimer);
        active = false;
        disableEvents();
		scene.remove( group);
		renderScene();
    }
    
    function showFloorPlan() {
        // get rid of booth gradients !!!
        container.appendChild( renderer.domElement);
        renderer.render( scene, camera);
        enableEvents();
        active = true;
		scene.add( group);
        updateCheck();
    }
    
    function checkBuilding() {
        if( floorMesh) {
            if( data.bDrawBuilding) {
                group.add( floorMesh);
            }
            else {
                group.remove( floorMesh);
            }
        }
    }
    
	
    //  Public interface
    return {
        addBoothGraphic: addBoothGraphic,
        addBuilding: addBuilding,
        addGraphic: addGraphic,
        addOverlays: addOverlays,
        addToOutline: addToOutline,
        completeSetup: completeSetup,
        dragTo: dragTo,
        fit: fitDrawing,
        getFloorPlanImage: printFloorPlan,
		getIsReady: function() { return isReady;},
        getOffset: function() { return { x: initialOffsetX, y: initialOffsetY};},
        getScale: function() { return fitScale; },
        getSelected: function() { return arSelected; },
        globalToFloorPlan: globalToFloorPlan,
        goToPoint: goToPoint,
        highlightBooth: highlightBooth,
        hitTest: hitTest,
        markFavorite: markFavorite,
        markSelected: markSelected,
        moveBy: function( dx, dy) {
            moveCamera( dx * fitScale, dy * fitScale);
        },
        redraw: function() {
            updateNeeded = true;
            checkBuilding();
                // if starting program, call once to start the loop
            if( !loopStarted) {
                loopStarted = true;
                updateCheck();
            }
        },
        pointerDownAt: pointerDownAt,
        remove3dFloorPlan: remove3dFloorPlan,
        removeAllSelected: removeAllSelected,
        removeBoothText: removeBoothText,
        removeFavorite: removeFavorite,
        removeFromOutline: removeFromOutline,
        removeSelected: removeSelected,
        resizeHandler: resizeHandler,
        showFloorPlan: showFloorPlan,
        setIAmHere: setIAmHere,
        updateSelected: updateSelected,
        zoom:  function( step) {
//            console.log( "Zoom step: " + step);
            cameraZoom( step);
        },
        zoomTo: function() {
            camera.position.z = initialCameraDistance / 2 - camera.position.y ;
            updateNeeded = true;
        }
    };
};